import _ from 'lodash';
import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { QuotationService, NodeType, AlertService, NewComment } from '../../../../services/index';
import { Util } from '../../../../utils/index';
declare var $:any;
import * as bigdecimal from 'bigdecimal';

@Component({
  selector: 'container-estimate-list',
  templateUrl: 'estimate-list.html',
})

export class EstimateListComponent implements AfterViewInit {
  @Input() cnsltnQuotLst;
  @Input() crncyRateLst;
  @Input() cnsltnReq;
  @Input() cnsltnCmntList;

  dateFomatter:Function = Util.dateFomatter;
  currencyFormat:Function = Util.currencyFormat;
  getLocalDtmStr:Function = Util.getLocalDtmStr;

  crncyValue: number = 0;
  crncy: string = '';

  bookedRequest;

  comment:NewComment = new NewComment();

  selectedCmnt: NewComment;
  showWriteComment: boolean = true;
  editCmnt: boolean = false;
  saveCmnt: boolean = false;
  
  @Output() bookingEe: EventEmitter<any> = new EventEmitter();

  constructor(
    private router:Router, 
    private quotationService: QuotationService, 
    private alertService:AlertService
  ) {}

  ngOnChanges()	{
    
    this.cnsltnQuotLst = _.orderBy(this.cnsltnQuotLst, ['stusCd', 'uptDtm' ], ['desc', 'asc']);
    
    this.getQuotLst(this.cnsltnQuotLst, this.crncyRateLst, this.cnsltnReq);
    this.commentOrder(this.cnsltnCmntList);
    
    if(this.cnsltnReq.quotNo){
      this.cnsltnQuotLst = _.sortBy(this.cnsltnQuotLst,(cnsltnQuot:any) =>{
        return this.cnsltnReq.quotNo.indexOf(cnsltnQuot.quotNo) > -1 ? 0 : 1
      });
    }
  }  

  clickEstimate(event){
    
    var animTime = 300;
    let el = event.currentTarget;
    var currIndex = $(el).index('.acc-btn'),
    targetHeight = $('.acc-content-inner').eq(currIndex).outerHeight();

    if($(el).find('section').attr('class').indexOf('selected') > -1){
      $(el).find('section').removeClass('selected');
      $(el).parent().find('.acc-content').stop().animate({ height: 0 }, animTime);
      $(el).parent().find('.acc-content').removeClass('open');
    }else{
      $(el).find('section').addClass('selected');
      $(el).parent().find('.acc-content').stop().animate({ height: targetHeight }, animTime);
      $(el).parent().find('.acc-content').addClass('open');
    }
  }

  ngAfterViewInit():void {
 
  }

  getQuotLst(quot, crncyRateLst, req) {
    this.crncy = crncyRateLst[this.crncyValue].crncyCd;
    let routes = [];

    for (var i=0; i < quot.length; i++) {
      // quot[i].optNum = 'Forwarder ' +  String.fromCharCode(65 + i);

      //라우터
      let quotRouteListBySeq = [];
      for(var j=0; j<quot[i].quotRouteList.length; j++) {
        let indexRoute = _.find(quot[i].quotRouteList, {'seq' : j});
        quotRouteListBySeq.push(indexRoute);
      }

      quot[i].quotRouteListBySeq = quotRouteListBySeq;
      
      this.getRouteType(quot[i].quotRouteListBySeq);


      //가격 합산 
      var depCosts = [];
      var transCosts = [];
      var arrCosts = [];    

      if(!quot[i] || !quot[i].summary) continue;
      
      //Total
      if(quot[i].totalCrncyCd){
        let crncyIdx = quot[i].summary.crncyIndexMap[quot[i].totalCrncyCd];
        quot[i].totalCrncy = quot[i].totalCrncyCd;
        quot[i].totalCost = quot[i].summary.totalCost[crncyIdx];
      }else{
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].totalCrncy = this.crncy; 
            quot[i].totalCost = quot[i].summary.totalCost[k];
          }
        }
      }
      //total 코스트 출력

      //출발지 코스트
      if(quot[i].orgCrncyCd) {
        let depCrncyIdx = quot[i].summary.crncyIndexMap[quot[i].orgCrncyCd];
        let depCosts = _.find(quot[i].summary.sumCostList, { cstTp : 0 });
        if(depCrncyIdx != null && depCosts != null) quot[i].depCost = depCosts.sumCost[depCrncyIdx];
        else quot[i].depCost = 0;
      } else {
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].orgCrncyCd = this.crncy; 
            let depCosts = _.find(quot[i].summary.sumCostList, { cstTp : 0 });
            if(depCosts != null) quot[i].depCost = depCosts.sumCost[k];
            else  quot[i].depCost = 0;
          }
        }
      }
      
      //도착지 코스트
      if(quot[i].desCrncyCd) {
        let arrCrncyIdx = quot[i].summary.crncyIndexMap[quot[i].desCrncyCd];
        let arrCosts = _.find(quot[i].summary.sumCostList, { cstTp : 1 });
        if(arrCrncyIdx != null && arrCosts != null) quot[i].arrCost = arrCosts.sumCost[arrCrncyIdx];
        else quot[i].arrCost = 0;
      } else {
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].desCrncyCd = this.crncy; 
            let arrCosts = _.find(quot[i].summary.sumCostList, { cstTp : 1 });
            if(arrCosts != null) quot[i].arrCost = arrCosts.sumCost[k];
            else quot[i].arrCost = 0;
          }
        }
      }

      //운송 운임
      if(quot[i].transCrncyCd) {
        let transCrncyIdx = quot[i].summary.crncyIndexMap[quot[i].transCrncyCd];
        let transCosts = null;
        transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 2 });
        if(transCosts == null)transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 3 });
        if(transCrncyIdx != null && transCosts != null) quot[i].transCost = transCosts.sumCost[transCrncyIdx];
        else quot[i].transCost = 0;
      } else {
        for (var k=0; k < quot[i].summary.totalCost.length; k++) {
          if(this.crncyValue == k) {
            quot[i].transCrncyCd = this.crncy; 
            let transCosts = null;
            transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 2 });
            if(transCosts == null) transCosts = _.find(quot[i].summary.sumCostList, { cstTp : 3 });
            
            if(transCosts != null) quot[i].transCost = transCosts.sumCost[k];
            else quot[i].transCost = 0;
          }
        }
      }
      
      
      quot[i].transTp = this.getTransTp();

      if(req.quotNo == quot[i].quotNo) {
        quot[i].booked = true;
      } else {
        quot[i].booked = false;
      }
    }
  }

  costSelection(costs, crncyCd) {
    var sumCosts;
    var sumCurrency;
    var multieCost = [];
    var biggest;
    var sumMultieCost;
    let bigSumCosts = new bigdecimal.BigDecimal(0);
     
    if(costs.length === 0){
      sumCosts = 0;
      sumCurrency = null;
    // } else if (costs.length === 1) {
    //   sumCosts = costs[0].cost;
    //   sumCurrency = costs[0].currency;
    }  else {
      for (var l = 0 ; l < costs.length; l++) {
        if(costs[l].currency !== 'KRW') {
          multieCost.push(costs[l].cost * costs[l].krwPerUnit);
        } else {
          multieCost.push(costs[l].cost);
        }
      }

      biggest = multieCost.indexOf(Math.max(...multieCost));

      sumMultieCost = multieCost.reduce(this.getSum);
      
      if(costs[biggest].currency == 'KRW') {
        sumCosts = sumMultieCost;
        sumCurrency = 'KRW';
      } 

      if(crncyCd){
        let unitPerKrw = 0;
        this.crncyRateLst.map(crncyRate =>{
          if(crncyRate.crncyCd.indexOf(crncyCd) > -1){
            unitPerKrw = crncyRate.unitPerKrw;
            return;
          }
        });
        sumCosts = sumMultieCost * unitPerKrw;
        sumCurrency = crncyCd;
      }else{
        sumCosts = sumMultieCost * costs[biggest].unitPerKrw;
        sumCurrency = costs[biggest].currency;
      }

      if(!sumCosts != null && sumCosts != undefined) bigSumCosts = new bigdecimal.BigDecimal(sumCosts);
    }
    return { cost: Math.round(sumCosts) > 0 ? Math.round(sumCosts) : '0', currency: sumCurrency };
    // return { cost: bigSumCosts.setScale(2, bigdecimal.RoundingMode.UP()).doubleValue(), currency: sumCurrency };
  }

  
  getSum(total, num) {
    return total + num;
  }

  getTransTp() {
    if(this.cnsltnReq.transTp == 0) {
      return '해상운송';
    } else {
      return '항공운송';
    }
  }

  getQuotRoute(routes, quot) {
    for (var i=0; i<quot.length; i++) {
      quot[i].routes = '';
      quot[i].routes =  _.find(routes, {'no': quot[i].quotNo});
      quot[i].quotRoutes = [];
    }
    

    for (var i=0; i<quot.length; i ++) {
      if(_.isEmpty(quot[i].routes)) {
        i++;
      } else if(_.isEmpty(quot[i].routes.route)) {
        i++;
      } else {
        if(quot[i].routes.route[0].typeCdNm == 'ORIGIN') {
          quot[i].quotRoutes = quot[i].routes.route;
        } else {
          for (var j=0; j<quot[i].routes.route.length; j++) {
            quot[i].quotRoutes.push({});
          }
          for (var j=0; j<quot[i].routes.route.length; j++) {
            quot[i].quotRoutes.splice(quot[i].routes.route[j].seq, 1, quot[i].routes.route[j]);
          }
        }
        
        this.getRouteType(quot[i].quotRoutes);
      }
    }    
  }

  commentOrder(commentList) {
    for(var i=0; i<this.cnsltnQuotLst.length; i++) {
      const quot = this.cnsltnQuotLst[i];
      quot.cmntList = _.filter(commentList, {quotNo: quot.quotNo, cmntType: 1});
      quot.rejectCmnt = _.filter(commentList, {quotNo: quot.quotNo, cmntType: 2});
      quot.showComment = false;
    }
  }


  getRouteType(quotRoutes) {
    let polIndex = -1;
		let podIndex = -1;
    
    for (var i=0; i<quotRoutes.length; i++) {
      var route = quotRoutes[i];
      route.transType = '';
      
      if(i < quotRoutes.length) {
        switch (route.typeCdNm) {  
          case 'PORT':
            route.transType = 'vessel';
            break;

          case 'AIRPORT':
            route.transType = 'air';
            route.transType = 'air';
            if(route.location && route.location.name) {
              let depstr = _.clone(route.location.name);
              depstr = depstr.replace(/international/i, "Int'l");
              depstr = depstr.replace(/airport/i, 'Apt.');
              route.location.nameShort = depstr;
            }
            break;

          case 'DOOR':
            route.transType = 'truck';
            break;

          case 'RAIL':
            route.transType = 'rail';
            break;

          default:
            route.transType = 'vessel';
        }
      }
      
      if(this.cnsltnReq.transTp == 1 && route.typeCd == NodeType.PORT){
				i = 0;
				continue;
			}

			if(this.cnsltnReq.transTp == 0 && route.typeCd == NodeType.AIRPORT){
				i = 0;
				continue;
			}

			if(polIndex == -1 && (route.typeCd == NodeType.PORT || route.typeCd == NodeType.AIRPORT)){
				polIndex = i;
			}
			if(polIndex > -1 && (route.typeCd == NodeType.PORT || route.typeCd == NodeType.AIRPORT)){
				podIndex = i;
			}
			if(route.typeNm == 'POL' || route.typeNm == 'POD'){
				if(route.typeCd == NodeType.AIRPORT){
					route.typeNm = 'AIR PORT';
				}else{
					route.typeNm = 'PORT';
				}
      }
    }

    if(polIndex > -1){
			quotRoutes[polIndex].typeNm = 'POL';
		}
		if(podIndex > -1){
      quotRoutes[podIndex].typeNm = 'POD';
      quotRoutes[podIndex].transType = 'truck';
      quotRoutes[podIndex].linerCd = null;
      quotRoutes[podIndex].linerNm = null;
    }
  }

  postBookingCheck(quot) {
    let that = this;
    if(this.cnsltnReq.quotNo != null) {
      $.sweetModal.confirm("기존 요청이 취소됩니다.", function() {
        that.postBooking(quot);
      });
    } else {
      this.postBooking(quot);
    }
    //승인 이후에만 부킹신청 변경안됨
  }

  postBooking(quot) {
    let that = this;
    $.sweetModal.confirm("부킹을 요청하시겠습니까?", function() {
      that.quotationService.postBooking(that.cnsltnReq.reqNo, quot.quotNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success("부킹이 요청되었습니다.");
            that.bookingEe.emit();
          } else {
            $.sweetModal({
              content: "부킹요청 실패",
              icon: $.sweetModal.ICON_WARNING,
            });
          }          
        }
      );
    });
  }

  cancelBooking(quot) {
    let that = this;
    $.sweetModal.confirm("부킹을 취소하시겠습니까?", function() {
      that.quotationService.cancelBooking(that.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            that.alertService.success("부킹이 취소되었습니다.");
            that.bookingEe.emit();
          } else {
            $.sweetModal({
              content: "부킹취소 실패",
              icon: $.sweetModal.ICON_WARNING,
            });
          }          
        }
      );
    });
  }

  goToFareAll() {
    let id = this.cnsltnReq.reqNo;
    this.router.navigate(['quotation', 'fare-all', id]);
  }

  goToFareDetail(quot) {
    let id = this.cnsltnReq.reqNo;
    let quotNo = quot.quotNo;

    this.router.navigate(['mypage', 'consult-detail', id, 'fare-temp', quotNo]);
  }

  
  moveFareDetail(quotNo:string){
    this.router.navigate(['/quotation/current', this.cnsltnReq.reqNo, quotNo]);
  }

  cancelConsultQuot(quotNo:string){
    if(this.cnsltnReq.stusCd > 1){
      $.sweetModal({
        content: "컨설팅 요청 상태에서만 견적 취소가 가능합니다.",
        icon: $.sweetModal.ICON_WARNING,
      });
      return false;
    }
    let that = this;
    $.sweetModal.confirm("취소한 견적은 사용이 불가능합니다.  \n 견적을 취소하시겠습니까?", function() {
      that.quotationService.cancelConsultQuot(quotNo).subscribe(
        resp => {
          if (resp.result) {
            that.bookingEe.emit();
            that.alertService.success("견적이 취소되었습니다.");
          } else {
            that.alertService.success("견적 취소가 실패되었습니다.");
          }          
        }
      );
    });
  }

  addComment(quot?, cmnt?) {
    if(cmnt) {
      this.comment.cmnt = cmnt.cmnt;
    };
    if(quot != null) this.comment.quotNo = quot.quotNo;
    this.comment.reqNo = this.cnsltnReq.reqNo;
    this.comment.corpId = 150;
    this.comment.cmntType = 1;
    this.saveCmnt = true;
    this.quotationService.addComment(this.cnsltnReq.reqNo, this.comment).subscribe(
      resp => {
        if(resp.result) {
          this.commentOrder(resp.data);
          this.comment.cmnt = null;
          Util.alertSuccess("저장이 완료 되었습니다.");
        } else {
          Util.alertWarn(resp.errorMsg);
        }
        this.saveCmnt = false;
      },
      error => {
        Util.alertWarn('오류가 발생했습니다. 다시한번 시도 해 주세요.');        
      },
      () => {
        this.saveCmnt = false;
      }
    )
  }

  handleShowComment(quot) {
    quot.showComment = !quot.showComment;
    this.showWriteComment = true;
    this.selectedCmnt = null;
  }

  clickOutsideComment(quot) {
    if(quot.showComment) {
      quot.showComment = false;
      this.selectedCmnt = null;
    }
  }

  handleSelectComment(cmnt) {
    this.selectedCmnt = cmnt;
    this.showWriteComment = false;
    this.editCmnt = false;
  }

  handleShowWrite() {
    if(this.showWriteComment) {
      this.showWriteComment = false;
    } else {
      this.selectedCmnt = null;
      this.showWriteComment = true;
    }
  }

  handleEditComment() {
    this.editCmnt = true;
  }

  replaceRow(cmnt: string) {
    return cmnt.replace(/\n/g, '<br/>');
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/estimate-list.ts